import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { PersonalizeExperienceInitStepDeclaration } from "./Steps/PersonalizeExperienceInitStep";

export const personalizeExperienceMainFlow = new FlowDefinition("PersonalizeExperienceFlow");

personalizeExperienceMainFlow.addStep(PersonalizeExperienceInitStepDeclaration);

personalizeExperienceMainFlow.setStartStep("PersonalizeExperienceInit_Step");

export const personalizeExperienceStartupFlowDefinition = new StepDefinition({
    stepName: "PersonalizeExperienceFlow",
    stepFlow: personalizeExperienceMainFlow
})
